<template>
  <div class="voucher-tag">
    <div class="voucher-tag-row">
      <span class="voucher-code">{{ voucherCode }}</span>
      <span v-if="voucherAmount" class="voucher-amount">
        {{ formatAmount(voucherAmount) }}
      </span>
    </div>
    <span class="tag-remove-icon" @click="onRemoveTag">
      <i class="fas fa-times"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: ['voucherCode', 'voucherAmount'],
  data() {
    return {};
  },
  methods: {
    onRemoveTag() {
      this.$emit('removeTag');
    },
    formatAmount(value) {
      if (!value) return '';
      return Number(value).toLocaleString('vi-VN') + 'đ';
    },
  },
};
</script>
<style>
.voucher-tag {
  display: inline-flex;
  align-items: center;
  background-color: rgb(53, 149, 246);
  border-radius: 5px;
  padding: 2px 6px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: #fff;
  line-height: 1.4;
  font-weight: 600;
  width: 100%;
}
.voucher-tag-row {
  flex: 1;
  min-width: 0;
  text-align: center;
}
.voucher-code {
  display: block;
}
.voucher-amount {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: #fff;
}
.tag-remove-icon {
  cursor: pointer;
  margin-left: 6px;
  flex-shrink: 0;
}
.tag-remove-icon i {
  font-size: 14px;
  color: white;
  transition: color 0.2s ease-in-out;
}
.tag-remove-icon i:hover {
  color: #333;
}
</style>